import {NavigationProp} from '@react-navigation/native';
import * as React from 'react';
import {Modal} from '../../../../../shared/components/modal/modal';
import {LocalParamList} from '../../../../../shared/components/tabBar/components/types';
import {useStyles} from '../../../../../shared/hooks/styles';
import {PhoneConfirmation} from '../../phoneConfirmation';

interface Props {
  navigation: NavigationProp<LocalParamList>;
  onClose: () => void;
}

export const PhoneConfirmationModal: React.FC<Props> = ({navigation, onClose}) => {
  const styles = useStyles(({theme}) => {
    return {
      wrapStyle: {
        paddingHorizontal: 65,
      },
      contentStyle: {
        paddingTop: 30,
      },
      titleStyle: {
        ...theme.fonts.h3,
        paddingTop: 0,
      },
    };
  });

  return (
    <Modal
      wrapStyle={styles.wrapStyle}
      contentStyle={styles.contentStyle}
      title='Подтвердите новый номер'
      titleStyle={styles.titleStyle}
      onClose={onClose}>
      <PhoneConfirmation navigation={navigation} onSubmit={onClose} />
    </Modal>
  );
};
